<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <defs>
    <linearGradient id="a" x1="15" x2="2.001" y1="2" y2="15" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0064FF"/>
      <stop offset="1" stop-color="#0037C5"/>
    </linearGradient>
  </defs>
  <path d="M13 9H3a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2ZM3 14a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2H3ZM13 4H3a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2Z"/>
  <path fill="url(#a)" d="M15 13.332a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z"/>
</svg>